// extracted by mini-css-extract-plugin
export default {"root":"Select-module__root___DpMaJ","default":"Select-module__default___zC_43","error":"Select-module__error___U8PGb","disabled":"Select-module__disabled___wIj_Y"};